;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.AccountChangePassword = Marionette.ItemView.extend({
		tagName: 'div',
		initialize: function() {
			this.user  = this.getOption('model');
			this.errors = false;
			this.form = new Backbone.Form({
				template: JST.changeAccountPassword,
				model: this.user
			});
			this.listenTo(this.form, 'password:blur passwordConfirm:blur', this.blur);
			this.customInitAdder();
			return this;
		},
		ui: {
			'submitForm': '#js-account-change-password'
		},
		events: {
			'click @ui.submitForm': 'changePass'
		},
		blur: function(form, editor){
			var errs = this.form.fields[editor.key].validate();

			switch (editor.key){
				case 'password':
					this.form.fields.passwordConfirm.validate();
					break;
				case 'passwordConfirm':
					this.form.fields.password.validate();
					break;
				default:
					break;
			}
			
			this.errors = errs && editor.previousValue;

			if (!errs && editor.previousValue) {
				$(editor.el).addClass('valid');
			}
			else {
				$(editor.el).removeClass('valid');
			}
			return this;
		},
		changePass: function(event) {
			event.preventDefault();

			if($(this.ui.submitForm).hasClass('success-update')){
				return;
			}

			var err = this.form.validate();

			_.find(this.fields, _.bind(function(value){
				if(_.has(err, value)){
					this.scrollToFieldError(err, value);
					return this.errors = true;
				}
			},this));

			this.showPreloader();

			if (this.errors) {
				this.hidePreloader();
				return;
			}
			var password = {password: this.form.getValue('password')};
			$.when.call(null,this.user.update(password)).done(_.bind(function(response){

				if (response.errors.length) {
					this.showErrors(response.errors);
				}
				else {
					var updated_data = _.extend(this.user.toJSON(), response.result.user);
					this.user.set(updated_data);

					APP.vent.trigger('user:get:profile');
					this.successUpdateFinish();

				}
				this.hidePreloader();
			}, this));

			return this;
		},
		render: function () {
			var _this = this;
			this.$el.html(this.form.render().el);
			this.showCurrentTab();
			return this;
		},
		showCurrentTab: function(){
			var _this = this;
			setTimeout(function(){
				$(_this.$el).find('.panel-body').addClass('open-tab');
			}, 10);
		},
		customInitAdder: function(){
			this.listenTo(this.form, 'change' , this.clearAll);
			return this;
		},
		successUpdateFinish: function(){
			$(this.ui.update_response).html('Thank you, your account has been updated');
			$(this.ui.submitForm).addClass('success-update').html('Password Changed');
		},
		clearAll: function(){
			$(this.ui.update_response).html('');
			$(this.ui.submitForm).removeClass('success-update').html('Change Password');
		}

	});

}(window, APP, Backbone, Marionette, $, _));

